import { combineReducers } from 'redux';
import { pages, STATE_KEY as PAGES_STATE_KEY } from './pages';
import { layouts, STATE_KEY as LAYOUTS_STATE_KEY } from './layouts';
import { placeholders, STATE_KEY as PLACEHOLDERS_STATE_KEY } from './placeholders';
import { images, STATE_KEY as IMAGES_STATE_KEY } from './images';
import { cover, STATE_KEY as COVER_STATE_KEY } from './cover';
import { io, STATE_KEY as IO_STATE_KEY } from './io';
import { texts, STATE_KEY as TEXTS_STATE_KEY } from './texts';
import { backgroundPlaceholders, STATE_KEY as BACKGROUND_PLACEHOLDERS_STATE_KEY } from './backgroundPlaceholders';

const entities = combineReducers({
  [PAGES_STATE_KEY]: pages,
  [LAYOUTS_STATE_KEY]: layouts,
  [PLACEHOLDERS_STATE_KEY]: placeholders,
  [IMAGES_STATE_KEY]: images,
  [TEXTS_STATE_KEY]: texts,
  [COVER_STATE_KEY]: cover,
  [IO_STATE_KEY]: io,
  [BACKGROUND_PLACEHOLDERS_STATE_KEY]: backgroundPlaceholders,
});

export default entities;



// WEBPACK FOOTER //
// ./src/redux/reducers/entities/index.js